import React from 'react';
import { tokens } from "@/tokens";

// Analytics Icon - bar chart with trend line
export const AnalyticsIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="14" width="4" height="6" rx="1" stroke={color} strokeWidth="1.5"/>
    <rect x="10" y="10" width="4" height="10" rx="1" stroke={color} strokeWidth="1.5"/>
    <rect x="17" y="6" width="4" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
    <path d="M5 10L12 5L19 3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 2"/>
  </svg>
);

// Customs ERP Icon - command terminal / ERP dashboard
export const ProductHubIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="20" height="18" rx="3" stroke={color} strokeWidth="1.5"/>
    <path d="M2 8H22" stroke={color} strokeWidth="1.5"/>
    <circle cx="5" cy="5.5" r="0.75" fill={color}/>
    <circle cx="7.5" cy="5.5" r="0.75" fill={color}/>
    <circle cx="10" cy="5.5" r="0.75" fill={color}/>
    <path d="M6 13L9 15.5L6 18" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 18H17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Trade Data Icon - database/layers
export const TradeDataIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="11" cy="6.5" rx="6.5" ry="2.5" stroke={color} strokeWidth="1.5" />
    <path d="M4.5 6.5V15.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17.5 6.5V15.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4.5 15.5A6.5 2.5 0 0 0 17.5 15.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Scenario Modeling - three sliders
export const ScenarioModelingIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Top slider */}
    <path d="M4 7H18" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="8" cy="7" r="2" stroke={color} strokeWidth="1.5"/>
    {/* Middle slider */}
    <path d="M4 11H18" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="14" cy="11" r="2" stroke={color} strokeWidth="1.5"/>
    {/* Bottom slider */}
    <path d="M4 15H18" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="6.5" cy="15" r="2" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Documents Icon - file/document
export const DocumentsIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.8333 2.75H5.5C4.95 2.75 4.58333 3.11667 4.58333 3.66667V18.3333C4.58333 18.8833 4.95 19.25 5.5 19.25H16.5C17.05 19.25 17.4167 18.8833 17.4167 18.3333V7.33333L12.8333 2.75Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.8333 2.75V7.33333H17.4167" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.6667 11.9167H7.33333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.6667 15.5833H7.33333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Compliance Icon - shield with checkmark
export const PostImportIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L4 6V11C4 16.25 7.4 21.14 12 22.5C16.6 21.14 20 16.25 20 11V6L12 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Partners Icon - building
export const PartnersIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.66667 19.25H18.3333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.58333 19.25V5.5C4.58333 4.39543 5.47876 3.5 6.58333 3.5H11C12.1046 3.5 13 4.39543 13 5.5V19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13 11H15.4167C16.5212 11 17.4167 11.8954 17.4167 13V19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.33333 7.33333H9.16667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.25 14.6667H9.16667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.33333 11H9.16667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Clients Icon - users/people
export const ClientsIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 11C13 8.79086 11.2091 7 9 7C6.79086 7 5 8.79086 5 11C5 13.2091 6.79086 15 9 15C11.2091 15 13 13.2091 13 11Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0386 7.55773C11.0131 7.37547 11 7.18927 11 7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C14.2554 11 13.5584 10.7966 12.9614 10.4423" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 21C15 17.6863 12.3137 15 9 15C5.68629 15 3 17.6863 3 21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 17C21 13.6863 18.3137 11 15 11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Settings Icon - gear/cog
export const SettingsIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z" stroke={color} strokeWidth="1.5"/>
    <path d="M21.011 14.0965C21.5329 13.9558 21.7939 13.8854 21.8969 13.7508C22 13.6163 22 13.3998 22 12.9669V11.0332C22 10.6003 22 10.3838 21.8969 10.2493C21.7938 10.1147 21.5329 10.0443 21.011 9.90358C19.0606 9.37759 17.8399 7.33851 18.3433 5.40087C18.4817 4.86799 18.5509 4.60156 18.4848 4.44529C18.4187 4.28902 18.2291 4.18134 17.8497 3.96596L16.125 2.98673C15.7528 2.77539 15.5667 2.66972 15.3997 2.69222C15.2326 2.71472 15.0442 2.90273 14.6672 3.27873C13.208 4.73448 10.7936 4.73442 9.33434 3.27864C8.95743 2.90263 8.76898 2.71463 8.60193 2.69212C8.43489 2.66962 8.24877 2.77529 7.87653 2.98663L6.15184 3.96587C5.77253 4.18123 5.58287 4.28891 5.51678 4.44515C5.45068 4.6014 5.51987 4.86787 5.65825 5.4008C6.16137 7.3385 4.93972 9.37763 2.98902 9.9036C2.46712 10.0443 2.20617 10.1147 2.10308 10.2492C2 10.3838 2 10.6003 2 11.0332V12.9669C2 13.3998 2 13.6163 2.10308 13.7508C2.20615 13.8854 2.46711 13.9558 2.98902 14.0965C4.9394 14.6225 6.16008 16.6616 5.65672 18.5992C5.51829 19.1321 5.44907 19.3985 5.51516 19.5548C5.58126 19.7111 5.77092 19.8188 6.15025 20.0341L7.87495 21.0134C8.24721 21.2247 8.43334 21.3304 8.6004 21.3079C8.76746 21.2854 8.95588 21.0973 9.33271 20.7213C10.7927 19.2644 13.2088 19.2643 14.6689 20.7212C15.0457 21.0973 15.2341 21.2853 15.4012 21.3078C15.5682 21.3303 15.7544 21.2246 16.1266 21.0133L17.8513 20.034C18.2307 19.8187 18.4204 19.711 18.4864 19.5547C18.5525 19.3984 18.4833 19.132 18.3448 18.5991C17.8412 16.6616 19.0609 14.6226 21.011 14.0965Z" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Riffs Intelligence Icon - sparkle brain / AI assistant
export const ChatAdvisorIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M9 21H15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 18V21" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14 18V21" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 2V6M12 6L14.5 4.5M12 6L9.5 4.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9.5" cy="10" r="1" fill={color}/>
    <circle cx="14.5" cy="10" r="1" fill={color}/>
  </svg>
);

// Tools Icon - calculator
export const DutyCalculatorIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 3C4 2.44772 4.44772 2 5 2H15C15.5523 2 16 2.44772 16 3V17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17V3Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 5H13.5V7.5H6.5V5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="7.5" cy="10.5" r="0.75" fill={color}/>
    <circle cx="10" cy="10.5" r="0.75" fill={color}/>
    <circle cx="12.5" cy="10.5" r="0.75" fill={color}/>
    <circle cx="7.5" cy="13.5" r="0.75" fill={color}/>
    <circle cx="10" cy="13.5" r="0.75" fill={color}/>
    <circle cx="12.5" cy="13.5" r="0.75" fill={color}/>
  </svg>
);

// Savings Icon - dollar bill
export const CoinsDollarIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="5" width="20" height="14" rx="2" stroke={color} strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5"/>
    <path d="M12 10.5V13.5" stroke={color} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M11 11.5C11 11.5 11 11 12 11C13 11 13 11.75 13 11.75C13 12.5 11 12.5 11 13.25C11 13.25 11 14 12 14C13 14 13 13.5 13 13.5" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="5.5" cy="12" r="0.75" fill={color}/>
    <circle cx="18.5" cy="12" r="0.75" fill={color}/>
  </svg>
);

// Logout Icon - logout arrow
export const LogoutIcon: React.FC<{ color?: string }> = ({ color = tokens.brand.accent }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6667 15.5833L19.25 11L14.6667 6.41667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.25 11H8.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.25 19.25H4.58333C4.03804 19.25 3.51516 19.0337 3.13134 18.6499C2.74752 18.2661 2.53125 17.7432 2.53125 17.1979V4.80208C2.53125 4.25679 2.74752 3.73392 3.13134 3.3501C3.51516 2.96628 4.03804 2.75 4.58333 2.75H8.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);


